"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _togaEmptyState = _interopRequireDefault(require("@thinkific/toga-empty-state"));

var _Filter = _interopRequireDefault(require("../Filter"));

var _Header = _interopRequireDefault(require("../Header"));

var _Dropdown = _interopRequireDefault(require("../Dropdown"));

var _constants = require("../constants");

var _Dropdown2 = _interopRequireDefault(require("../Dropdown.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var cx = _bind["default"].bind(_Dropdown2["default"]);

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      dimensions = props.dimensions,
      open = props.open,
      width = props.width,
      headerContent = props.headerContent,
      filter = props.filter,
      position = props.position,
      emptyState = props.emptyState;
  var localClassName = cx('dropdown__menu', className, {
    'is-visible': open,
    'is-hidden': !open,
    'dropdown__menu-right': position === 'right'
  });

  if (width) {
    console.warn("'width' will be removed from Dropdown/Menu component"); // eslint-disable-line no-console
  }

  var style = width;

  if (dimensions.menu) {
    style = dimensions.menu;
  }

  var regex = new RegExp(filter.filterString, 'i');

  var filteredChildren = _react.Children.toArray(children).filter(function (c) {
    return c.props && regex.test(c.props.title);
  });

  if (filteredChildren.length === 0 && filter.filterString.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: localClassName
    }, /*#__PURE__*/_react["default"].createElement(_togaEmptyState["default"], _extends({}, emptyState, {
      style: {
        width: 340
      },
      cardStyle: true
    })));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: localClassName,
    style: style
  }, headerContent && /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    content: headerContent
  }), filter.isVisible && /*#__PURE__*/_react["default"].createElement(_Filter["default"], {
    placeholder: filter.placeholder,
    value: filter.filterString,
    onChange: filter.onFilterChange
  }), /*#__PURE__*/_react["default"].createElement("ul", {
    className: cx('dropdown__list')
  }, filteredChildren));
};

Menu.displayName = 'Menu';
Menu.propTypes = {
  /** HTML Node that will appear in the dropdown when clicked */
  children: _propTypes["default"].node,

  /** Override classes if provided * */
  className: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),

  /** Object with maxWidth, minWidth and width * */
  dimensions: _constants.DROPDOWN_DIMENSIONS_PROP_TYPE,

  /** Value of the empty state object */
  emptyState: _propTypes["default"].shape({
    description: _propTypes["default"].string,
    icon: _propTypes["default"].string,
    title: _propTypes["default"].string
  }),

  /** Filter object */
  filter: _propTypes["default"].shape({
    filterString: _propTypes["default"].string,
    isVisible: _propTypes["default"].bool,
    placeholder: _propTypes["default"].string,
    show: _propTypes["default"].bool,
    onFilterChange: _propTypes["default"].func
  }),

  /** String that first appear in the hidden menu */
  headerContent: _propTypes["default"].string,

  /** Flag to control if the dropdown menu is open or closed */
  open: _propTypes["default"].bool,
  // eslint-disable-line react/boolean-prop-naming

  /** Menu position - use right to right-align the menu */
  position: _propTypes["default"].string,

  /** Menu width */
  width: _propTypes["default"].number
};
Menu.defaultProps = {
  children: null,
  className: null,
  dimensions: _Dropdown["default"].defaultProps.dimensions,
  open: false,
  width: null,
  headerContent: '',
  position: null,
  filter: {
    isVisible: false,
    filterString: '',
    placeholder: null,
    onFilterChange: function onFilterChange() {}
  },
  emptyState: {
    icon: null,
    title: null,
    description: null
  }
};
var _default = Menu;
exports["default"] = _default;